import axios from 'axios';
import { getTokenCredentials } from '../../../Shared/functions';
import { BASE_API } from '../../../Shared/Constants';


export function getFactors(body){ 
    return axios.post(BASE_API+'api/factor/get', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
        throw error.response.data.message;
    });
}

export function insertFactors(body){ 
    return axios.post(BASE_API+'api/factor/register', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }   
        throw error.response.data.message;
    });
}